// extracted by mini-css-extract-plugin
export var box = "_96-1";
export var checkboxRow = "_96-8";
export var checked = "_96-2";
export var descriptionSpacer = "_96-a";
export var disabled = "_96-3";
export var icon = "_96-6";
export var input = "_96-0";
export var labelSpacer = "_96-9";
export var medium = "_96-5";
export var small = "_96-4";
export var text = "_96-7";